// src/components/AddGoalForm.jsx
import React, { useState } from 'react';
import '../Style/goalAdd.css';
import CharCounter from '../components/CharCounter';

const Difficulty = {
  EASY: 'EASY',
  MEDIUM: 'MEDIUM',
  HARD: 'HARD',
};

const REMINDER_DAYS = [
  { label: 'Mon', value: 'MONDAY' },
  { label: 'Tue', value: 'TUESDAY' },
  { label: 'Wed', value: 'WEDNESDAY' },
  { label: 'Thu', value: 'THURSDAY' },
  { label: 'Fri', value: 'FRIDAY' },
  { label: 'Sat', value: 'SATURDAY' },
  { label: 'Sun', value: 'SUNDAY' },
];

function UserAddGoalForm({ onAdd, onClose = () => {} }) {
  const [title, setTitle] = useState('');
  const [difficulty, setDifficulty] = useState(Difficulty.EASY);
  const [dailyHabit, setDailyHabit] = useState(false);

  const [reminderEnabled, setReminderEnabled] = useState(false);
  const [reminderTime, setReminderTime] = useState('');
  const [reminderDays, setReminderDays] = useState([]);

  const TITLE_MAX = 100;

  const handleToggleDay = (dayValue) => {
    setReminderDays((prevDays) => {
      if (prevDays.includes(dayValue)) {
        return prevDays.filter((day) => day !== dayValue);
      }

      return [...prevDays, dayValue];
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!title.trim()) {
      alert('Please enter a goal title.');
      return;
    }

    if (reminderEnabled && !reminderTime) {
      alert('Please choose a reminder time.');
      return;
    }

    if (reminderEnabled && reminderDays.length === 0) {
      alert('Please choose at least one reminder day.');
      return;
    }

    onAdd({
      title: title.trim(),
      difficulty,
      dailyHabit,
      reminderEnabled,
      reminderTime: reminderEnabled && reminderTime ? reminderTime : null,
      reminderDays: reminderEnabled ? reminderDays : [],
    });

    setTitle('');
    setDifficulty(Difficulty.EASY);
    setDailyHabit(false);
    setReminderEnabled(false);
    setReminderTime('');
    setReminderDays([]);
    onClose();
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <h2 style={{ marginTop: 0, letterSpacing: '-0.025em' }}>New Objective</h2>

        <form onSubmit={handleSubmit} data-testid="add-goal-form">
          <div style={{ marginBottom: '20px' }}>
            <label className="form-label">Goal Title</label>
            <input
              data-testid="goal-title-input"
              className={`input-field ${title.length >= TITLE_MAX ? 'input-error' : ''}`}
              type="text"
              autoFocus
              value={title}
              maxLength={TITLE_MAX}
              onChange={(e) => setTitle(e.target.value)}
              placeholder="e.g. Read 10 books this year, Run 5km without stopping.."
            />
            <CharCounter current={title.length} max={TITLE_MAX} />
          </div>

          <div style={{ marginBottom: '24px' }}>
            <label className="form-label">Difficulty Level</label>
            <select
              data-testid="goal-difficulty-select"
              className="input-field"
              value={difficulty}
              onChange={(e) => setDifficulty(e.target.value)}
            >
              <option value={Difficulty.EASY}>Easy (10 XP)</option>
              <option value={Difficulty.MEDIUM}>Medium (25 XP)</option>
              <option value={Difficulty.HARD}>Hard (50 XP)</option>
            </select>
          </div>

          <div style={{ marginBottom: '16px' }}>
            <label
              className="form-label"
              style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
            >
              <input
                type="checkbox"
                checked={reminderEnabled}
                onChange={(e) => {
                  const checked = e.target.checked;
                  setReminderEnabled(checked);

                  if (!checked) {
                    setReminderTime('');
                    setReminderDays([]);
                  }

                  // Optional: if daily habit is already checked, auto-select all days
                  if (checked && dailyHabit && reminderDays.length === 0) {
                    setReminderDays(REMINDER_DAYS.map((day) => day.value));
                  }
                }}
              />
              Enable reminder
            </label>
          </div>

          {reminderEnabled && (
            <>
              <div style={{ marginBottom: '20px' }}>
                <label className="form-label">Reminder Time</label>
                <input
                  data-testid="goal-title-input"
                  className="input-field"
                  type="time"
                  value={reminderTime}
                  onChange={(e) => setReminderTime(e.target.value)}
                />
              </div>

              <div style={{ marginBottom: '24px' }}>
                <label className="form-label">Reminder Days</label>

                <div
                  style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '8px',
                    marginTop: '8px',
                  }}
                >
                  {REMINDER_DAYS.map((day) => (
                    <button
                      key={day.value}
                      type="button"
                      onClick={() => handleToggleDay(day.value)}
                      className={reminderDays.includes(day.value) ? 'btn-primary' : 'btn-secondary'}
                      style={{
                        padding: '8px 12px',
                        minWidth: '48px',
                      }}
                    >
                      {day.label}
                    </button>
                  ))}
                </div>
              </div>
            </>
          )}

          <div style={{ display: 'flex', gap: '12px' }}>
            <button type="button" className="btn-secondary" style={{ flex: 1 }} onClick={onClose}>
              Cancel
            </button>
            <button
              type="submit"
              className="btn-primary"
              data-testid="create-goal-submit-button"
              style={{ flex: 1 }}
            >
              Create Goal
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default UserAddGoalForm;
